import { render, staticRenderFns } from "./MovModal.vue?vue&type=template&id=40edc0fc&scoped=true&lang=pug"
import script from "./MovModal.vue?vue&type=script&lang=ts"
export * from "./MovModal.vue?vue&type=script&lang=ts"
import style0 from "./MovModal.vue?vue&type=style&index=0&id=40edc0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40edc0fc",
  null
  
)

export default component.exports